<template>
    <div class="my-discount">
        <div class="myTitle3">自助优惠列表</div>
        <ul class="dislist el-row">
            <li v-for="(item, i) of list" :key="i" @click="toPage(item)">
                <template v-if="item.mPicture">
                    <div>
                        <img loading="lazy" v-lazy="$common.getImgUrl(item.mPicture)" />
                    </div>
                </template>
                <template v-else>
                    <div>
                        <img loading="lazy"
                            v-if="item.type == 4"
                            v-lazy="require('../../../assets/images/my/discount11.png')"
                        />
                        <img loading="lazy"
                            v-if="item.type == 5"
                            v-lazy="require('../../../assets/images/my/discount13.png')"
                        />
                        <img loading="lazy"
                            v-if="item.type == 6"
                            v-lazy="require('../../../assets/images/my/discount14.png')"
                        />
                        <img loading="lazy"
                            v-if="item.type == 7"
                            v-lazy="require('../../../assets/images/my/discount15.png')"
                        />
                        <img loading="lazy"
                            v-if="item.type == 8"
                            v-lazy="require('../../../assets/images/my/discount16.png')"
                        />
                        <img loading="lazy"
                            v-if="item.type == 9"
                            v-lazy="require('../../../assets/images/my/discount17.png')"
                        />
                        <img loading="lazy"
                            v-if="item.type == 10"
                            v-lazy="require('../../../assets/images/my/discount18.png')"
                        />
                        <img loading="lazy"
                            v-if="item.type == 11"
                            v-lazy="require('../../../assets/images/my/discount19.png')"
                        />
                    </div>
                </template>
                <div>
                    <p class="title">{{ item.name }}</p>
                    <p class="count">{{ item.summary }}</p>
                </div>
                <span></span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [],
        };
    },
    created() {
        debugger;
        let data = {
            pageSize: 40,
        };
        this.$http
            .post(this.$api.getThematicActivitiesListByApp, data)
            .then((res) => {
                if (res.code == 0) {
                    let content = res.data.content;
                    this.list = content.filter((item) => {
                        return (
                            item.type != 1 && item.type != 2 && item.type != 3
                        );
                    });
                }
            });
    },
    methods: {
        toPage(value) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            switch (value.type) {
                case 4:
                    this.$router.push({
                        path: "/my/discount/credentials",
                        query: {
                            id: value.id,
                        },
                    });
                    break;
                case 5:
                    this.$router.push({
                        path: "/my/discount/week",
                        query: {
                            id: value.id,
                        },
                    });
                    break;
                case 6:
                    this.$router.push({
                        path: "/my/discount/lucky",
                        query: {
                            id: value.id,
                        },
                    });
                    break;
                case 7:
                    this.$router.push({
                        path: "/my/discount/anniversary",
                        query: {
                            id: value.id,
                        },
                    });
                    break;
                case 8:
                    this.$router.push({
                        path: "/my/discount/Reward",
                        query: {
                            id: value.id,
                            name: value.name,
                        },
                    });
                    break;
                case 9:
                    this.$router.push({
                        path: "/my/discount/Rescue",
                        query: {
                            id: value.id,
                            name: value.name,
                        },
                    });
                    break;
                case 10:
                    this.$router.push({
                        path: "/my/discount/manyTimes",
                        query: {
                            id: value.id,
                        },
                    });
                    break;
                case 11:
                    this.$router.push({
                        path: "/my/discount/feedback",
                        query: {
                            id: value.id,
                        },
                    });
                    break;
            }
        },
    },
};
</script>
<style lang="scss">
    @import url('../../../assets/css/common.css');
.my-discount {
    .disTop {
        margin-top: 30px;
        position: relative;
        border-bottom: 1px solid #e3e8eb;
        padding-bottom: 30px;
        img {
            width: 60px;
            height: 60px;
            float: left;
            margin-right: 28px;
        }
        .disTopCount {
            color: #999;
            .disTopCountp1 {
                font-size: 16px;
                color: #222;
                padding-top: 8px;
                padding-bottom: 6px;
                span {
                    color: #06f;
                }
            }
            .disTopCountp2 {
                font-size: 13px;
                span {
                    margin: 0 20px;
                }
                label {
                    font-size: 16px;
                    color: #333;
                    font-family: Arial;
                    margin: 0 2px;
                    font-weight: 600;
                }
            }
        }
        .disTopVip {
            width: 128px;
            height: 48px;
            overflow: hidden;
            text-indent: 40px;
            background: url(../../../assets/images/my/discount1.jpg) no-repeat 0
                0;
            color: #fff;
            text-align: left;
            line-height: 48px;
            font-size: 14px;
            font-weight: 600;
            position: absolute;
            right: -35px;
            top: 0;
        }
    }
    .myTitle3 {
        border-left: 4px solid #f01924;
        font-size: 14px;
        color: #222;
        font-weight: 700;
    }
    .dislist {
        li {
            box-sizing: border-box;
            padding: 13px 0;
            float: left;
            margin-bottom: 12px;
            width: 49%;
            transition: all 0.15s;
            cursor: pointer;
            border-radius: 4px;
            border: 1px solid #e3e8eb;
            box-shadow: 0 3px 15px 0 rgba(125, 160, 184, 0.2);
            &:nth-child(2n) {
                margin-left: 2%;
            }
            img {
                width: 58px;
                height: 58px;
                float: left;
                margin: 0 20px;
            }
            div {
                float: left;
                .title {
                    color: #333;
                    font-size: 16px;
                    font-weight: 600;
                }
                .count {
                    font-size: 12px;
                    color: #999;
                    margin-top: 10px;
                }
            }
            span {
                width: 13px;
                height: 22px;
                float: right;
                background: url(../../../assets/images/my/discount1.jpg)
                    no-repeat;
                background-position: 0 -22px;
                transition: all 0.1s;
                margin-top: 17px;
                margin-right: 20px;
            }
            &:hover {
                border-color: #c7d2d7;
                transform: translateY(-3px);
                span {
                    background-position: 0 0;
                }
            }
        }
    }
}
</style>